<div class="content">
  <router-outlet></router-outlet>
  @if (!whiteLabel) {
    <app-footer></app-footer>
  }
  @if (buildNumber) {
    <div class="build-number" [ngClass]="{ black: whiteLabel }">
      Build {{ buildNumber }}
      @if (apiURL) {
        <span> - {{ apiURL }}</span>
      }
    </div>
  }
</div>
